/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useCallback, useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../../components/ui-elements/table/StyledTableRow';
import { IconButton, Typography } from '@mui/material';
import { BsFillPencilFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import RoleEdit from './RoleEdit';
import Loader from '../../../../../../components/ui-elements/loader';
import RoleHistory from './RoleHistory';
import { FaHistory } from 'react-icons/fa';
import { getAllRole } from '../../../../../../store/reducers/role/roleAction';
import { RolePropTypes } from '../../models/roleModel';
import PropTypes from 'prop-types';

const RolesList = () => {
    const [selectedRole, setSelectedRole] = useState({});
    const [openEditRole, setOpenEditRole] = useState(false);
    const [openHistoryRole, setOpenHistoryRole] = useState(false);
    const [loading, setLoading] = useState(false);
    const roles = useSelector(state => state.role.roles);
    const dispatch = useDispatch()

    const fetchRoles = useCallback(async () => {
        try {
            setLoading(true);
            await dispatch(getAllRole()).unwrap();
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }

    }, [dispatch]);
    useEffect(() => {
        fetchRoles()
    }, [fetchRoles]);
    const handleCloseDialog = () => {
        setOpenEditRole(false);
        setOpenHistoryRole(false);
    }

    return (
        <>
            {!loading ? <TableContainer component={Paper}>
                <Table sx={{ minWidth: 700 }} aria-label="customized table">
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell label="Role Name" />
                            <StyledTableCell label="Details" />
                            <StyledTableCell label=" " />

                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {roles?.length > 0 && roles.map((row) => (
                            <StyledTableRow key={row.username}>
                                <StyledTableCell label={row.roleName} />

                                <StyledTableCell   >
                                    {row.roleDetails.length > 0 ?
                                        <Typography style={{ fontWeight: 'bold' }} color={row.roleDetails[0].detailValue === "true" ? 'primary' : 'error'}>
                                            {row.roleDetails[0].detailValue === "true" ? 'Authorized' : 'Unauthorized'}
                                        </Typography> : "N/A"}
                                </StyledTableCell>
                                <StyledTableCell align="right"  >
                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedRole(row); setOpenEditRole(true) }}>
                                        <BsFillPencilFill />
                                    </IconButton>
                                    <IconButton color='primary' style={{ marginRight: '30px' }} onClick={() => { setSelectedRole(row); setOpenHistoryRole(true) }}>
                                        <FaHistory />
                                    </IconButton>
                                </StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer> : (<Loader />)}

            <DialogContainer
                open={openEditRole}
                handleClose={handleCloseDialog}
            >
                <RoleEdit
                    selectedRole={selectedRole}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
            <DialogContainer
                open={openHistoryRole}
                handleClose={handleCloseDialog}
            >
                <RoleHistory
                    selectedRole={selectedRole}
                    handleClose={handleCloseDialog} />
            </DialogContainer>
        </>
    )

}
RolesList.propTypes = {
    roles: PropTypes.arrayOf(RolePropTypes).isRequired,
};
export default RolesList;
